import { environment } from '../../environments/environment';

/**
 * The pre-auth entry route for unauthenticated users.
 *
 * Tenant-first login (cell-routing): a user must pick their Tenant_Slug before
 * authenticating so the request can be routed to the tenant's Cell. The tenant
 * picker lives at `/tenant`.
 *
 * Demo mode keeps the self-contained legacy `/auth/login` → `/auth/demo-sso`
 * flow (no real backend / edge router involved).
 */
export const AUTH_ENTRY_ROUTE = environment.demoMode ? '/auth/login' : '/tenant';

/**
 * Route prefixes that are themselves part of the pre-auth flow. Used to avoid
 * redirect loops (e.g. an APP_INITIALIZER session probe failing while the user is
 * already sitting on the picker / login page).
 */
const PRE_AUTH_PREFIXES = ['/auth/', '/tenant'];

/** True when the given URL is already on a pre-auth page (so we must not redirect again). */
export function isPreAuthUrl(url: string): boolean {
  return PRE_AUTH_PREFIXES.some(prefix => url.startsWith(prefix));
}
